import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Footer from '../components/Footer';

const imageBase = process.env.PUBLIC_URL || '';
const asset = (name) => `${process.env.PUBLIC_URL}/images/${name}`;

const products = {
  'Compression-Shirt': {
    mainImage: asset('compression_shirt.avif'),
    mainAlt: 'Compression Shirt, front view',
    thumbnails: [
      { image: asset('compressionShirt_back.avif'), alt: 'Compression Shirt, detail view 1' },
     
    ],
    name: 'The Compression Shirt',
    price: '$75',
    description:
      'A premium material design for comfort and performance with a clean modern look.',
    sizes: ['S', 'M', 'L', 'XL'],
  },
  'Y-3 Ant Jersey': {
    mainImage: `${imageBase}/images/jersey.avif`,
    mainAlt: 'Miami jersey front view',
    thumbnails: [
      
      { image: asset('jersey_Front.avif'), alt: 'Miami jersey detail view 2' },
     
    ],
    name: 'Y-3 Ant Jersey',
    price: '$75',
    description: 'A sharp, comfortable jersey for everyday wear and match-day energy.',
    sizes: ['S', 'M', 'L', 'XL'],
  },
  'Basketball-Shorts': {
    mainImage: `${imageBase}/images/ball_short_Fit.avif`,
    mainAlt: 'Basketball Shorts front view',
    thumbnails: [
      { image: asset('ball_shorts.avif'), alt: 'Basketball Shorts detail view 1' },
      { image: asset('short_backView.avif'), alt: 'Basketball Shorts detail view 2' },
      
    ],
    name: 'Legacy 3-Stripe Shorts',
    price: '$75',
    description: 'Built for a bold look with a lightweight feel and classic fit.',
    sizes: ['S', 'M', 'L', 'XL'],
  },
  'the-grey-hoodie': {
    mainImage: `${imageBase}/images/hoodie.avif`,
    mainAlt: 'The Grey Hoodie front view',
    thumbnails: [
      { image: asset('hoodie.avif'), alt: 'The Grey Hoodie detail view 1' },
      { image: asset('backHoodie.avif'), alt: 'The Grey Hoodie detail view 2' },
      
    ],
    name: 'The Grey Hoodie',
    price: '$80',
    description: 'A fresh colorway with a relaxed, easy-fit silhouette.',
    sizes: ['S', 'M', 'L', 'XL'],
  },

};

const sizeChart = {
  image: asset('high-neck-updated.avif'),
  alt: 'Size chart reference',
  label: 'SIZE CHART',
  title: 'The Sweatshirt',
  description: 'Peak is 5\'6" and wears a Small.',
};

const relatedStyles = [
  { 
    image: asset('shoe_1.avif'), 
    alt: 'Related style 1',
    name: 'Performance Court Shoe',
    price: '$120.00'
  },
  { 
    image: asset('shoe_2.avif'), 
    alt: 'Related style 2',
    name: 'Unisole Low Top',
    price: '$110.00'
  },
  { 
    image: asset('shoe_3.avif'), 
    alt: 'Related style 3',
    name: 'Pro Trainer',
    price: '$135.00'
  },
  { 
    image: asset('shoe_4.avif'), 
    alt: 'Related style 4',
    name: 'Elite High Top',
    price: '$145.00'
  },
];

export default function ItemPage({ onAddToCart }) {
  const { slug } = useParams();
  const [selectedSize, setSelectedSize] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const product = products[slug] || products['light-grey-shirt'];

  const handleAddToCart = () => {
    onAddToCart?.({
      image: product.mainImage,
      alt: product.mainAlt,
      name: product.name,
      size: selectedSize,
      price: product.price,
      quantity: quantity,
    });
  };

  const decreaseQty = () => setQuantity((q) => Math.max(1, q - 1));
  const increaseQty = () => setQuantity((q) => q + 1);

  return (
    <>
      <header>
        <nav className="nav-main">
          <h1>PeakPerformance</h1>
          <ul className="nav-menu">
           <li className="nav-item"><Link className="button-nav" to="/">Home</Link></li>
            <li className="nav-item">
              <Link className="button-nav" to="/shop">Shop</Link>
            </li>
            <li className="nav-item">
              <Link className="button-nav" to="/checkout">Checkout</Link>
            </li>
            <li className="nav-item">
              <Link className="button-nav" to="/contact">Contact</Link>
            </li>
          </ul>
        </nav>
      </header>
      <section className="item-page">
        <div className="item-gallery">
          <div className="item-thumbnails">
            {product.thumbnails.map((thumb) => (
              <img
                key={thumb.image}
                className="item-thumbnail"
                src={thumb.image}
                alt={thumb.alt}
              />
            ))}
          </div>
          <img
            className="item-main-image"
            src={product.mainImage}
            alt={product.mainAlt}
          />
        </div>

        <div className="item-details">
          <h1 className="item-name">{product.name}</h1>

          <p className="item-description">{product.description}</p>

          <h2 className="item-price">{product.price}</h2>

          <div className="item-sizes">
            {product.sizes.map((size) => (
              <button
                key={size}
                type="button"
                className={
                  'item-size' + (selectedSize === size ? ' item-size-selected' : '')
                }
                onClick={() => setSelectedSize(size)}
              >
                {size}
              </button>
            ))}
          </div>

          <div className="item-actions">
            <div className="item-quantity">
              <button
                type="button"
                className="item-quantity-btn"
                onClick={decreaseQty}
                aria-label="Decrease quantity"
              >
                −
              </button>
              <span className="item-quantity-value">{quantity}</span>
              <button
                type="button"
                className="item-quantity-btn"
                onClick={increaseQty}
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>

            <button type="button" className="item-add-to-cart" onClick={handleAddToCart}>
              Add To Cart
            </button>
          </div>
        </div>

        <div className="item-size-chart-container">
          <img className="item-size-chart-image" src={sizeChart.image} alt={sizeChart.alt} />
          <div className="item-size-chart-text">
            <p className="item-size-chart-label">{sizeChart.label}</p>
            <h3 className="item-size-chart-title">{sizeChart.title}</h3>
            <p className="item-size-chart-description">{sizeChart.description}</p>
          </div>
      </div>
      </section>

      <section id="item-related-styles" className="item-related-styles">
        <h2 className="item-related-heading">Related Styles</h2>
        <div className="item-related-row">
          {relatedStyles.map((item) => (
            /* The new wrapper div for each product */
            <div key={item.image} className="item-related-card">
              
              <img
                className="item-related-image"
                src={item.image}
                alt={item.alt}
              />
              
              {/* The new text details */}
              <div className="item-related-details">
                <h3 className="item-related-name">{item.name}</h3>
                <p className="item-related-price">{item.price}</p>
              </div>

            </div>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
}